import { GridAnimationSettings as GridAnimationSettings_internal } from "./GridAnimationSettings";
/**
 * Animation settings for the grid.
*/
var IgrGridAnimationSettings = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridAnimationSettings() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridAnimationSettings.prototype.createImplementation = function () {
        return new GridAnimationSettings_internal();
    };
    Object.defineProperty(IgrGridAnimationSettings.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridAnimationSettings.prototype.onImplementationCreated = function () {
    };
    IgrGridAnimationSettings.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    return IgrGridAnimationSettings;
}());
export { IgrGridAnimationSettings };
//# sourceMappingURL=igr-grid-animation-settings.js.map
